const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const getPublicAssetUrl = (assetPath: string) => {
  const baseUrl = stripTrailingSlash(process.env.PUBLIC_URL || '');
  const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;

  return `${baseUrl}${normalizedPath}`;
};

export default getPublicAssetUrl;
